import { ChangeDetectionStrategy, Component } from '@angular/core';
import licenses from '@json-data/licenses.json';
import { BaseModalComponent } from '@ui/modal/base-modal.component';
import { ModalComponent } from '@ui/modal/modal.component';
import { CellTemplateDirective } from '@ui/table/cell-template.directive';
import { TableComponent } from '@ui/table/table.component';
import { TableColumn, TableOptions } from '@ui/table/table.types';

type Attribution = {
  name: string;
  version: string;
  license: string;
  homepage?: string;
  description?: string;
  repository?: string;
};

@Component({
  selector: 'app-license-attribution',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, TableComponent, CellTemplateDirective],
  templateUrl: './license-attribution.component.html',
  styleUrls: ['./license-attribution.component.scss'],
})
export class LicenceAttributionComponent extends BaseModalComponent {
  readonly #dependencies = licenses[0]?.dependencies ?? {};
  protected readonly columns: TableColumn[] = [
    { field: 'name', templateName: 'nameTemplate', headerStyleClass: 'w-20rem' },
    { field: 'version' },
    { field: 'license' },
    { field: 'links', templateName: 'linksTemplate', sortable: false },
    { field: 'description' },
  ];
  protected readonly tableOptions: TableOptions = { globalSearch: false, showPagination: false };

  protected readonly rows: Attribution[] = Object.keys(this.#dependencies).map((key: string) => {
    const licenseItem: Attribution = this.#dependencies[key];
    return {
      ...licenseItem,
      repository: licenseItem?.repository?.replace('git+', ''),
      name: key,
    };
  });
}
